import { styleTags } from '@/helpers/qbankParser/styleTags';
import { stripTags } from '@/helpers/utils';
import { headerEtcCd02, headerEtcCd01, headerBookCd, difficult } from './qbankMeta';

const qbankAssetUrl = process.env.VUE_APP_DS_QBANK_ASSET_URL;

/**
 * 스타일 속성값 변환
 * @param {*} v
 * @returns
 */
export const rsStyle = (v, img = false, txArea = false, exc = false) => {
    let rsS = '';
    Object.entries(v).forEach(([key, value]) => {
        // console.log('----rsStyle--key--',key)
        // console.log('----rsStyle--value--',value)
        if (txArea && key === 'height') {
            rsS += 'min-height:' + value + 'px;';
        } else if (exc !== false && exc === key) {
            //
        } else if (key === 'size' && value !== null && value !== '') {
            // rsS += 'font-size:' + value + (!isNaN(Number(value)) ? 'pt;' : ';');
            rsS += 'font-size:' + Number(value)?.toFixed(1) + (!isNaN(Number(value)) ? 'pt;' : ';');
        } else if (!img || key !== 'height') {
            if (styleTags[key] && value !== null && value !== '') {
                rsS += styleTags[key] + ':' + value + (!isNaN(Number(value)) ? 'px;' : ';');
            }
        }
    });
    // console.log('----rsStyle--v--',v)
    // console.log('----rsStyle--rsS--',rsS)

    return rsS;
};

/**
 * 스타일 태그 변환
 * @param {*} textArea
 * @returns
 */
export const transferStyleTag = (textArea) => {
    let result = textArea
        .replace(/<(BOLD)>/g, '<strong>')
        .replace(/<(\/BOLD)>/g, '</strong>')
        .replace(/<(ITALIC)>/g, '<i>')
        .replace(/<(\/ITALIC)>/g, '</i>')
        .replace(/<(UNDERLINE)>/g, '<u style="text-underline-position: under;">')
        .replace(/<(\/UNDERLINE)>/g, '</u>')
        .replace(/<(STRIKEOUT)>/g, '<del>')
        .replace(/<(\/STRIKEOUT)>/g, '</del>')
        .replace(/<(SHAPECHAR)/g, '<span class="deco-shapeChar"')
        .replace(/<(\/SHAPECHAR)>/g, '</span>')
        .replace(/<(HIDEBLOCK)>/g, '<span class="deco-hideBlock">')
        .replace(/<(\/HIDEBLOCK)>/g, '</span>')
        .replace(/<(CHARBOX)>/g, '<span class="deco-charBox">')
        .replace(/<(\/CHARBOX)>/g, '</span>')
        .replace(/<(BREAKLINE)>/g, '<span class="deco-breakLine">')
        .replace(/<(\/BREAKLINE)>/g, '</span>')
        .replace(/<(ITEMPOINT)/g, '<span class="deco-itemPoint"')
        .replace(/<(\/ITEMPOINT)>/g, '</span>')
        // .replace(/<(TOOLTIPAREA)/g, `<details class="tooltipBox"><summary`)
        // .replace(/<(\/TOOLTIPAREA)>/g, '</summary></summary></details>')
        // .replace(/<(TOOLTIPTEXT)/g, `<details class="tooltipText"><summary`)
        // .replace(/<(\/TOOLTIPTEXT)>/g, '</summary></summary></details>');

        // ToolTipText 태그 적용을 위해 주석 해제
        .replace(/<(TOOLTIPAREA)/g, '')
        .replace(/<(\/TOOLTIPAREA)>/g, '')
        // 예외 케이스 추가
        .replace(/<(TEXT)/g, '<div')
        .replace(/<(\/TEXT)>/g, '</div>')
        .replace(/<(TABLE)/g, '<table style="min-width:100%"')
        //
        .replace(/<(ROW)/g, '<tr')
        .replace(/<(\/ROW)>/g, '</tr>')
        .replace(/<(CELL)/g, '<td')
        .replace(/<(\/CELL)>/g, '</td>')
        .replace(/<(SUPERSCRIPT)/g, '<sup')
        .replace(/<(\/SUPERSCRIPT)>/g, '</sup>')
        // .replace(/<(CHAR size\="15.6")>/g, '')
        // .replace(/<(\/CHAR)>/g, '')
        .replace(/<(IMAGE)/g, '<img')
        .replace(/<(\/IMAGE)>/g, '</img>')
        // .replace(/path\=\"/g, 'align="center" src="' + process.env.VUE_APP_DS_QBANK_ASSET_URL);
        .replace(/path\=\"/g, 'align="top" src="' + process.env.VUE_APP_DS_QBANK_ASSET_URL);
    // .replace(/<(TOOLTIPTEXT)/g, '')
    // .replace(/<(\/TOOLTIPTEXT)>/g, '');
    //console.log(textArea);
    return result;
};

/**
 * 태그제거 < ~ /> 패턴만
 * @param {*} v
 * @returns
 */
export const removeTag = (v) => {
    // return v.replace(/(?=\<)(.*?)(?<=\/\>)/, '');
};

/**
 * 모든 태그제거 < ~ /> 패턴만
 * @param {*} v
 * @returns
 */
export const removeTagAll = (v) => {
    // return v.replace(/(?=\<)(.*?)(?<=\/\>)/g, '');
};

/**
 * elements 를 html로 반환
 * @param {*} text  // elements
 * @returns // Html String
 */
let inputIdx = 1;
export const elParser = (text) => {
    let rsStr = '';
    for (const element of text) {
        let content = '';
        let tag = 'p';
        let itemStyle = '';
        let etcAtt = '';
        Object.entries(element).forEach(([key, value]) => {
            if (key == 'textBox') {
                tag = 'div';
                // itemStyle = rsStyle(value);
                // textBox padding 추가
                itemStyle = 'padding:10px;' + rsStyle(value);
                if (value.elements?.length > 0) {
                    let isEleNull = true;
                    value.elements.forEach((el) => {
                        Object.values(el).forEach((ell) => {
                            if (ell?.content !== '') {
                                isEleNull = false;
                            }
                        });
                    });
                    rsStr += '<' + tag + ' style="' + itemStyle + '"' + etcAtt + ' >' + elParser(value.elements) + '</' + tag + '>';
                    // if (isEleNull) {
                    //     rsStr += '<' + tag + ' style="' + itemStyle + '"' + etcAtt + ' >' + transferStyleTag(value.content) + '</' + tag + '>';
                    // } else {
                    //     rsStr += '<' + tag + ' style="' + itemStyle + '"' + etcAtt + ' >' + elParser(value.elements) + '</' + tag + '>';
                    // }
                } else {
                    rsStr += '<' + tag + ' style="' + itemStyle + '"' + etcAtt + ' >' + value.content + '</' + tag + '>';
                }
            } else if (key == 'text') {
                // tag = 'p';  // 복붙시 줄바꿈 들어가서 변경
                tag = 'div';
                itemStyle = rsStyle(value);
                let addText = '';
                if (value.content.startsWith('-<CHAR')) {
                    addText = '-';
                }
                if (value.elements?.length > 0) {
                    rsStr += '<' + tag + ' style="' + itemStyle + '"' + etcAtt + ' >' + addText + elParser(value.elements) + '</' + tag + '>';
                } else {
                    rsStr += '<' + tag + ' style="' + itemStyle + '"' + etcAtt + ' >' + addText + value.content + '</' + tag + '>';
                }
            } else if (key == 'char') {
                tag = 'span';
                itemStyle = rsStyle(value);
                if (value.elements?.length > 0) {
                    if (value.elements[0].hasOwnProperty('inputBox') || value.elements[0].hasOwnProperty('inputBlock')) {
                        if (value.content.startsWith('<INPUT') && value.content.endsWith('/>')) {
                            rsStr += '<' + tag + ' style="' + itemStyle + '"' + etcAtt + ' >' + elParser(value.elements) + '</' + tag + '>';
                        } else {
                            const inputCnt = value.content.match(/INPUT/g);
                            // let tmpContent = value.content;
                            // inputCnt.forEach((item, ii) => {
                            //     // tmpContent = tmpContent.replace(/(?=\<INPUT)(.*?)(?<=\/\>)/, exInput(value.elements[ii]));
                            //     // 사파리 호환성 변경
                            //     tmpContent = tmpContent.replace(/\<INPUT.*\/>/gi, exInput(value.elements[ii]));
                            // });
                            //  사파리 호환성 변경 ==========>
                            let tmpContent = '';
                            const tmpArr = value.content.split('<INPUT');
                            tmpArr.map((item, index) => {
                                if (index !== 0) {
                                    let fIndex = item.indexOf('/>') + 2;
                                    tmpContent += exInput(value.elements[index - 1]) + item.substr(fIndex);
                                } else {
                                    tmpContent += item;
                                }
                            });
                            //  사파리 호환성 변경 ==========>
                            rsStr +=
                                '<' +
                                tag +
                                ' style="' +
                                itemStyle +
                                '"' +
                                etcAtt +
                                ' >' +
                                tmpContent +
                                // transferStyleTag(value.content) +
                                '</' +
                                tag +
                                '>';
                        }
                    } else if (value.elements[0].hasOwnProperty('image')) {
                        if (value.content.startsWith('<IMAGE') && value.content.endsWith('/>')) {
                            rsStr += '<' + tag + ' style="' + itemStyle + '"' + etcAtt + ' >' + elParser(value.elements) + '</' + tag + '>';
                        } else {
                            rsStr += '<' + tag + ' style="' + itemStyle + '"' + etcAtt + ' >' + transferStyleTag(value.content) + '</' + tag + '>';
                        }
                    } else {
                        rsStr += '<' + tag + ' style="' + itemStyle + '"' + etcAtt + ' >' + elParser(value.elements) + '</' + tag + '>';
                        // rsStr += '<' + tag + ' style="' + itemStyle + '"' + etcAtt + ' >' + dataToParse.transferStyleTag(value.content) + '</' + tag + '>'
                    }
                } else {
                    if (value.content === ' ') {
                        // rsStr += '<br />';
                        rsStr += '&nbsp ';
                    } else {
                        rsStr += '<' + tag + ' style="' + itemStyle + '"' + etcAtt + ' >' + transferStyleTag(value.content) + '</' + tag + '>';
                    }
                }
            } else if (key == 'table') {
                tag = 'table';
                itemStyle = rsStyle(value);
                if (value.rows?.length > 0) {
                    rsStr += '<' + tag + ' style="width:100%;' + itemStyle + '"' + etcAtt + ' >' + elParser(value.rows) + '</' + tag + '>';
                } else {
                    rsStr += '<' + tag + ' style="width:100%;' + itemStyle + '"' + etcAtt + ' >' + value.content + '</' + tag + '>';
                }
            } else if (key == 'cells') {
                tag = 'tr';
                itemStyle = rsStyle(value);
                let trStr = '';
                const tdInit = (v) => {
                    let tdStyle = rsStyle(v);
                    let tdAtt = '';
                    v.rowspan && (tdAtt += 'rowspan=' + v.rowspan + ' ');
                    v.colspan && (tdAtt += 'colspan=' + v.colspan + ' ');
                    if (v.content != '') {
                        return '<td ' + tdAtt + ' style="' + tdStyle + '"' + ' >' + elParser(v.elements) + '</td>';
                    } else {
                        return '<td ' + tdAtt + ' style="' + tdStyle + '"' + ' ></td>';
                    }
                };
                value.rowspan && (etcAtt += 'rowspan=' + value.rowspan + ' ');
                value.colspan && (etcAtt += 'colspan=' + value.colspan + ' ');
                if (value.length > 0) {
                    value.forEach((item) => {
                        trStr += tdInit(item);
                    });
                    rsStr += '<' + tag + ' style="' + itemStyle + '"' + etcAtt + ' >' + trStr + '</' + tag + '>';
                } else {
                    rsStr += '<' + tag + ' style="' + itemStyle + '"' + etcAtt + ' ></' + tag + '>';
                }
            } else if (key == 'image') {
                tag = 'img';
                // tag = 'image';
                // itemStyle = rsStyle(value);
                itemStyle = 'max-width: 100%;' + rsStyle(value, true); // 이미지 최대 크기 고정
                etcAtt += 'src="' + qbankAssetUrl + value?.path + '" ';
                if (value.elements?.length > 0) {
                    rsStr += '<' + tag + ' style="' + itemStyle + '"' + etcAtt + ' >' + content + '</' + tag + '>';
                } else {
                    rsStr += '<' + tag + ' style="' + itemStyle + '"' + etcAtt + ' >' + content + '</' + tag + '>';
                    // content = value.content
                }
            } else if (key == 'inputBlock') {
                // tag =
                //     'q-input clearable outlined id="input_answer' +
                //     inputIdx +
                //     '" :v-model="answer.value' +
                //     inputIdx +
                //     '" ';
                tag = value.multiline ? 'textArea autocomplete="off" class="input_answers" id="input_answer' + inputIdx + '" ' : 'input autocomplete="off" class="input_answers" id="input_answer' + inputIdx + '" ';
                // console.log('tag');
                // console.log(tag);
                inputIdx += 1;
                itemStyle = value.multiline ? rsStyle(value, false, true) : rsStyle(value);
                if (value.elements?.length > 0) {
                    if (value.multiline) {
                        rsStr += '<' + tag + ' style="' + itemStyle + '"' + etcAtt + ' ></textArea>';
                    } else {
                        rsStr += '<' + tag + ' style="' + itemStyle + '"' + etcAtt + ' />';
                    }
                    // +
                    //     // elParser(value.elements, idx) +
                    //     '</' +
                    //     tag +
                    //     '>';
                } else {
                    if (value.multiline) {
                        rsStr += '<' + tag + ' style="' + itemStyle + '"' + etcAtt + ' ></textArea>';
                    } else {
                        rsStr += '<' + tag + ' style="' + itemStyle + '"' + etcAtt + ' />';
                    }
                    // rsStr += '<' + tag + ' style="' + itemStyle + '"' + etcAtt + ' />';
                    // +
                    //     value.content +
                    //     '</' +
                    //     tag +
                    //     '>';
                }
            } else if (key == 'inputBox') {
                // tag =
                //     'q-input clearable outlined id="input_answer' +
                //     inputIdx +
                //     '" v-model="answer.value' +
                //     inputIdx +
                //     '" ';
                tag = value.multiline ? 'textArea autocomplete="off" class="input_answers" id="input_answer' + inputIdx + '" ' : 'input autocomplete="off" class="input_answers" id="input_answer' + inputIdx + '" ';
                // console.log('tag');
                // console.log(tag);
                inputIdx += 1;
                itemStyle = value.multiline ? rsStyle(value, false, true) : rsStyle(value);
                if (value?.elements?.length > 0) {
                    if (value.multiline) {
                        rsStr += '<' + tag + ' style="' + itemStyle + '"' + etcAtt + ' ></textArea>';
                    } else {
                        rsStr += '<' + tag + ' style="' + itemStyle + '"' + etcAtt + ' />';
                    }
                    // rsStr += '<' + tag + ' style="' + itemStyle + '"' + etcAtt + ' />';
                    // +
                    //     // elParser(value.elements) +
                    //     '</' +
                    //     tag +
                    //     '>';
                } else {
                    if (value.multiline) {
                        rsStr += '<' + tag + ' style="' + itemStyle + '"' + etcAtt + ' ></textArea>';
                    } else {
                        rsStr += '<' + tag + ' style="' + itemStyle + '"' + etcAtt + ' />';
                    }
                    // rsStr += '<' + tag + ' style="' + itemStyle + '"' + etcAtt + ' />';
                    // +
                    //     // value?.content +
                    //     '</' +
                    //     tag +
                    //     '>';
                }
            } else if (key == 'toolTipText') {
                tag = 'char';
                itemStyle = rsStyle(value);
                rsStr += transferStyleTag(value.content).replaceAll('<sup>', '<sup title ="' + unescape(value.text) + '">');
            } else if (key == 'eq') {
                if (value.content.startsWith('<![CDATA[') && value.content.endsWith(']]>')) {
                    let tmpContent = value.content;
                    rsStr += tmpContent.substr(0, tmpContent.length - 3).substr(9);
                }
            } else {
                //
            }
        });
        // rsStr += '<' + tag + ' style="' + itemStyle + '"' + etcAtt + ' >' + content + '</' + tag + '>';
    }
    return rsStr;
};

/**
 * getHeader
 * @param {*} data
 * @returns string
 */
export const getChoice = (data) => {
    let choiceArr = data.content.problem.choice.items;
    let rsArr = [];
    choiceArr.forEach((item) => {
        const tmpTexts = item.textBoxes ? item.textBoxes : item.texts;
        let tmpText = '';
        tmpTexts.forEach((item) => {
            tmpText += '<div ' + ' style="' + rsStyle(item) + '"' + ' >' + elParser(item.elements) + '</div>';
        });
        rsArr.push({ num: item.num, numChar: item.numChar, text: tmpText });
    });
    return { array: data.content.problem.choice.array, data: rsArr };
};
/**
 * getHeader
 * @param {*} data
 * @returns string
 */
export const getHeader = (data, isVoca = false) => {
    // let headerArr =
    //     data.content.header.content.texts.length === 0
    //         ? data.content.header.content.textBoxes
    //         : data.content.header.content.texts;
    if (data.content.header) {
        // let headerArr = data.content.header?.content?.texts.length !== 0 ? data.content.header.content.texts : [];
        // if (data.content.header?.content?.textBoxes.length !== 0) {
        //     headerArr = [...headerArr, ...data.content.header.content.textBoxes];
        // }
        // let result = '';
        // headerArr.forEach((item) => {
        //     // result += '<div style="' + rsStyle(item, false, false, 'align') + '">' + elParser(item.elements) + '</div>';
        //     result += '<div >' + elParser(item.elements) + '</div>';
        // });
        let result = '';
        let textArr = data.content.header?.content?.texts.length !== 0 ? data.content.header.content.texts : [];
        let textBoxArr = data.content.header?.content?.textBoxes.length !== 0 ? data.content.header.content.textBoxes : [];
        textArr.forEach((item) => {
            // result += '<div style="' + rsStyle(item, false, false, 'align') + '">' + elParser(item.elements) + '</div>';
            if (!isVoca) {
                item?.elements.forEach((ii) => {
                    // console.log(ii);
                    if (ii?.char && ii?.char?.content !== '') {
                        if (ii?.char.elements.length > 0) {
                            result += '<div >' + elParser(ii?.char.elements) + '</div>';
                        } else {
                            result += '<div style="' + rsStyle(ii?.char, false, false, 'align') + '">' + transferStyleTag(ii?.char.content) + '</div>';
                        }
                    }
                    if (ii?.textBox && ii?.textBox.content !== '') {
                        result += '<div >' + elParser(ii?.textBox.elements) + '</div>';
                    }
                });
            } else {
                result += '<div style="' + rsStyle(item, false, false, 'align') + '">' + elParser(item.elements) + '</div>';
            }
        });
        textBoxArr.forEach((item) => {
            if (!isVoca) {
                // result += '<div style="' + rsStyle(item, false, false, 'align') + '">' + elParser(item.elements) + '</div>';
                result += '<div >' + elParser(item.elements) + '</div>';
            } else {
                result += '<div style="' + rsStyle(item, false, false, 'align') + '">' + elParser(item.elements) + '</div>';
                // result += '<div >' + elParser(item.elements) + '</div>';
            }
        });
        return result;
    } else {
        return '';
    }
};

/**
 * getHeaderTitle
 * @param {*} data
 * @returns string
 */
export const getHeaderTitle = (data) => {
    let result = '';
    try {
        if (data.content.header != null) {
            result = data.content.header.etc.etcTxt01 == null ? '' : data.content.header.etc.etcTxt01;
        }
    } catch (error) {
        // console.log(error);
    }
    return result;
};

export const getQuestion_old = (data, num = false) => {
    // console.log('--getQuestion_old- vvvv-', data.content.problem.question.texts[1].elements[0].textBox.elements[0].text.elements[0].char)
    // console.log('--getQuestion_old- ffff-', data.content.problem.question.texts[1].elements[0].textBox.elements[0].text.elements[0].char)
    // console.log('--getQuestion_old- aaaa-',data.content.problem.question.texts[1].elements[0].textBox.elements[0].text.elements[0].char.content)

    let numset = false;
    let numStyle = '<span style="font-weight:700;margin-right:10px;">' + num + '.</span>';
    let textArr = data.content.problem.question.texts.length !== 0 ? data.content.problem.question.texts : [];
    let textBoxArr = [];
    if (data.content.problem.question.textBoxes.length !== 0) {
        textBoxArr = data.content.problem.question.textBoxes;
    }
    // console.log('--getQuestion_old-textArr-', textArr)
    let result = '';
    inputIdx = 1;
    textArr.forEach((item) => {
        if (stripTags(item.content) !== ' ') {
            // console.log('--getQuestion_old-textArr-rsStyle(item)-', rsStyle(item))
            if (!numset && num !== false) {
                result += '<div style="margin-bottom:10px;' + rsStyle(item) + '">' + numStyle + elParser(item.elements) + '</div>';
                numset = true;
            } else {
                if (item.elements.length > 0) result += '<div style="margin-bottom:10px;' + rsStyle(item) + '">' + elParser(item.elements) + '</div>';
                else result += '<div style="margin-bottom:10px;' + rsStyle(item) + '">' + transferStyleTag(item.content) + '</div>';
            }
        }
    });
    textBoxArr.forEach((item) => {
        if (stripTags(item.content) !== ' ') {
            if (!numset && num !== false) {
                result += '<div style="padding:10px;' + rsStyle(item) + '">' + numStyle + elParser(item.elements) + '</div>';
                numset = true;
            } else {
                result += '<div style="padding:10px;' + rsStyle(item) + '">' + elParser(item.elements) + '</div>';
            }
        }
    });
    inputIdx = 1;
    return result;
};

export const getQuestion = (data) => {
    let isTextBox = data.content.problem.question.textBoxes.length !== 0;
    let titleArr = isTextBox ? data.content.problem.question.textBoxes : data.content.problem.question.texts;
    let title = '';
    let result = [];
    titleArr.forEach((item, index) => {
        if (index === 0) {
            title = '<div style="' + rsStyle(item);
            +'" >' + elParser(item.elements) + '</div>';
        } else {
            result.push({
                style: rsStyle(item),
                conent: elParser(item.elements),
            });
        }
    });

    return { title, result, isTextBox };
};

export const getAnswerDetail = (data) => {
    let resultDetails = [];

    let answerDetails = data.content.solution.answer?.detail;
    answerDetails.forEach((item) => {
        resultDetails.push(item.answer);
    });

    return resultDetails;
};
export const getAnswer = (data) => {
    let resultTexts = '';
    let resultDetails = '';
    let answerTexts = data.content.solution.answer?.texts;
    answerTexts.forEach((item) => {
        resultTexts += stripTags(item.content) + '<br />';
    });
    let answerDetails = data.content.solution.answer?.detail;
    let isMultiAns = answerDetails?.length > 1 ? answerDetails[answerDetails.length - 1].ord > 1 : false;
    answerDetails.forEach((item) => {
        if (isMultiAns) {
            resultDetails += '(' + item.ord + ') ' + item.answer + '<br />';
        } else {
            resultDetails += item.answer + '<br />';
        }
    });
    let answerExplain = getAnswerExplain(data);
    let answerHint = getAnswerHint(data);
    return {
        detail: resultDetails,
        texts: resultTexts,
        explain: answerExplain,
        hint: answerHint,
    };
};

export const getAnswerExplain = (data) => {
    let contentArr = data.content.solution.explain.texts ? data.content.solution.explain.texts : data.content.solution.explain.textBoxes;
    let result = '';
    contentArr.forEach((item) => {
        result += '<div style="' + rsStyle(item) + '">' + elParser(item.elements) + '</div>';
    });
    result = stripTags(result).replaceAll(' ', '') === '' ? null : result;
    return result;
};

export const getAnswerHint = (data) => {
    let contentArr = data.content.solution.hint.texts ? data.content.solution.hint.texts : data.content.solution.hint.textBoxes;
    let result = '';
    contentArr.forEach((item) => {
        result += '<div style="' + rsStyle(item) + '">' + elParser(item.elements) + '</div>';
    });
    result = stripTags(result).replaceAll(' ', '') === '' ? null : result;
    return result;
};

/**
 * 크리드 점수
 * @param {*} data
 * @returns
 */
export const getKreadScore = (data) => {
    let result;
    try {
        result = data.content.header.etc.etcTxt03 == null ? '' : data.content.header.etc.etcTxt03;
    } catch (error) {
        result = '';
    }
    return result;
};

/**
 * 워드크라우드차트용 태그 제외한 지문 추출
 * @param {*} data
 * @returns
 */
export const getHeaderText = (data) => {
    // let contentQuesArr =
    //     data.content.header.content.texts.length > 0
    //         ? data.content.header.content.texts
    //         : data.content.header.content.textBoxes;

    // if (contentQuesArr.length > 1) {
    //     return stripTags(contentQuesArr[1].content);
    // } else {
    //     return stripTags(contentQuesArr[0].content);
    // }
    return stripTags(getHeader(data));
};

/**
 * 표준 읽기 시간 //TODO: etcTxt 번호 변경 될수있음
 * @param {*} data
 * @returns
 */
export const getStandardReadingTime = (data) => {
    let result = '';
    try {
        if (data.content.header != null) {
            result = data.content.header.etc.etcTxt04 == null ? 0 : data.content.header.etc.etcTxt04;
        }
    } catch (error) {
        // console.log(error);
    }
    return result;
};
/**
 * 표준 읽기 시간 //TODO: etcTxt 번호 변경 될수있음
 * @param {*} data
 * @returns
 */
export const getEtcInfo_old = (data) => {
    let result = {};
    try {
        if (data.content.header != null) {
            result = {
                kread: data.content.header.etc.etcTxt04 === null ? 0 : data.content.header.etc.etcTxt04,
                title: data.content.header.etc.etcTxt01 === null ? 0 : data.content.header.etc.etcTxt01,
                writer: data.content.header.etc.etcTxt02 === null ? 0 : data.content.header.etc.etcTxt02,
                etcCd01: data.content.header.etc.etcCd01 == null ? 0 : data.content.header.etc.etcCd01,
                etcCd01Nm: data.content.header.etc.etcCd01 == null ? '' : headerEtcCd01[data.content.header.etc.etcCd01],
                etcCd02: data.content.header.etc.etcCd02 == null ? 0 : data.content.header.etc.etcCd01,
                etcCd02Nm: data.content.header.etc.etcCd02 == null ? '' : headerEtcCd02[data.content.header.etc.etcCd02],
                bookNm: data.content.problem.headerBookCd == null ? '' : headerBookCd[data.content.problem.headerBookCd],
            };
        }
    } catch (error) {
        // console.log(error);
    }
    return result;
};
/**
 * 표준 읽기 시간 //TODO: etcTxt 번호 변경 될수있음
 * @param {*} data
 * @returns
 */
export const getEtcInfo = (data) => {
    let result = {};
    try {
        if (data.content.property != null) {
            result = {
                kread: data.content.property.header.etcTxt03 === null ? 0 : data.content.property.header.etcTxt03,
                title: data.content.property.header.etcTxt01 === null ? '' : data.content.property.header.etcTxt01,
                writer: data.content.property.header.etcTxt02 === null ? '' : data.content.property.header.etcTxt02,
                etcCd01: data.content.property.header.etcCd01 == null ? 0 : data.content.property.header.etcCd01,
                etcCd01Nm: data.content.property.header.etcCd01 == null ? '' : headerEtcCd01[data.content.property.header.etcCd01],
                etcCd02: data.content.property.header.etcCd02 == null ? 0 : data.content.property.header.etcCd01,
                etcCd02Nm: data.content.property.header.etcCd02 == null ? '' : headerEtcCd02[data.content.property.header.etcCd02],
                bookNm: data.content.property.problem.bookNm == null ? '' : data.content.property.problem.bookNm,
                solveTime: data.content.property.problem.solveTime == null ? 0 : data.content.property.problem.solveTime,
                analysis: data.content.property.analysis.analysisNm == null ? '' : data.content.property.analysis.analysisNm,
                difficultCd: data.content.property.analysis.difficultCd == null ? '03' : data.content.property.analysis.difficultCd,
                difficultNm: data.content.property.analysis.difficultCd == null ? '03' : difficult[data.content.property.analysis.difficultCd]?.label,
            };
        }
    } catch (error) {
        // console.log(error);
    }
    return result;
};

const exInput = (txt) => {
    let rsStr = '';
    //2024-02-07 ljs 사용자가 직접 input에 입력 시 2000자 제한
    Object.entries(txt).forEach((key, value) => {
        let tag = value?.multiline ? 'textArea autocomplete="off" maxlength="2000" class="input_answers" id="input_answer' + inputIdx + '" ' : 'input autocomplete="off" maxlength="2000" class="input_answers" id="input_answer' + inputIdx + '" ';
        // let tag = 'input autocomplete="off" class="input_answers" id="input_answer' + inputIdx + '" ';
        inputIdx += 1;
        let itemStyle = rsStyle(value);
        if (value?.elements?.length > 0) {
            rsStr += '<' + tag + ' style="' + itemStyle + '"' + ' />';
        } else {
            rsStr += '<' + tag + ' style="' + itemStyle + '"' + ' />';
        }
    });
    return rsStr;
};
